import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from "@angular/common/http";
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';

import { GridOptionsModel, ColumnDefinitionsModel, PaginationsModel, FetchCriteriaModel, FilterService, CustomGridExtendedComponent }
  from 'lib/ng2-sapmp/src/ui-components/custom-grid-extended';

  import { deviceInventory } from 'config';
import { BreadCrumbService, StepIndicatorService, DropdownModel } from 'lib/ng2-sapmp/src/ui-components';
import { ChipsService } from 'lib/ng2-sapmp/src/ui-components/chips/chips.service';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';

import { DevicesModel } from '../model/grouping-devices.model';
import { GroupingDevicesService } from '../grouping-devices.service';
import { IndexedDbService} from '../../../indexed-db.service';

@Component({
  selector: 'app-select-devices',
  templateUrl: './select-devices.component.html',
  styleUrls: ['./select-devices.component.scss'],
  encapsulation: ViewEncapsulation.None,
  // providers: [IndexedDbService]
})
export class SelectDevicesComponent implements OnInit {
  
  public pageJson;
  showErrors: boolean;
  reviewData: any;
  rowData: any =[];
  filterRowData: Array<DevicesModel>;
  selectedRowData: any =[];
  gridOptions: GridOptionsModel;
  customGridOptions = new GridOptionsModel();
  selectDevicesCol: any = deviceInventory.selectDevices;

  public numberPattern = new RegExp("^[0-9]*$");
  public modelPattern = new RegExp("^[0-9a-zA-Z-\\s]*$");
  isctnNumberInvalid: boolean;
  isimeiNumberInvalid: boolean;
  isModelInvalid: boolean;
  selectedFan: any;
  public ctn: any;
  public imei: any;
  public deviceModel: any;
  public status: any;
  public group: any;
  public defaultGroup={ name: "Select", value: "" };
  public defaultStatus={ name: "Select", value: "" };
  statusOptions: any = [];
  groupsOptions: any = [{ name: "Select", value: "" }];
  public groupingDevicesDetails: any;
  public numberOfRowsSelected: number;
  public showNumberOfRowsSelected: boolean = false;
  totalNumberOfRecords:number;

  constructor(private stepIndicatorService: StepIndicatorService,
    private httpClient: HttpClient,
    private route: ActivatedRoute,
    private chips: ChipsService,
    private pageloaderService: PageLoaderService,
    private utilityService: UtilityService,
    private router: Router,
    private breadCrumbService: BreadCrumbService,
    private groupingDevicesService: GroupingDevicesService,
    private dbService: IndexedDbService
  ) { 
    
  }

  ngOnInit(): void {

    this.pageloaderService.setPageLoaderStatus(false);
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.pageJson = this.route.snapshot.data.pageData.groupingDevicesselectDevices;
    this.statusOptions  = this.pageJson.status;
    this.selectedFan = sessionStorage.getItem("selectedFAN");
    this.chips.setChips([{
      "label": "Home",
      "routerLink": "/home"
    }, {
      "label": "Manage Accounts",
      "routerLink": "/manageInventory"
    }, {
      "label": 'Devices for foundation account   ' + this.selectedFan,
      "routerLink": "manageInventory/deviceInventory"
    }, {
      "label": "Group Devices",
      "routerLink": "/groupingDevices/selectDevices"
    }]);

    
    //this.getGroupingDevicesData();
    var sessionId = sessionStorage.getItem("sessionId");
    this.groupingDevicesService
      // .getDeviceInventory(this.selectedFanId, this.pageSize, pageNumber)
      .getGroupDevicesData(this.selectedFan, sessionId)
      .subscribe(
        (respobj) => {
          this.dbService.clearData('devices');
          this.dbService.addData("devices", respobj);
          this.groupingDevicesDetails = respobj; //JSON.parse(localStorage.getItem("groupDeviceTableData"));
    
          this.rowData = this.groupingDevicesDetails.list;
          this.totalNumberOfRecords = this.groupingDevicesDetails.totalNumberOfRecords;
          
          let backurl = sessionStorage.getItem('callingURL');
          if(backurl === '/groupingDevices/selectGroup' ||  backurl === '/groupingDevices/review'){
            this.selectedRowData = JSON.parse(sessionStorage.getItem('selectedDevicesForGrouping'));
            if(this.selectedRowData.length>0){
              this.showNumberOfRowsSelected = true;
              this.numberOfRowsSelected = this.selectedRowData.length;
            }
            
            for(let i=0; i<this.selectedRowData.length; i++){
              for(let j=0; j<this.rowData.length; j++){
                  if(this.selectedRowData[i].ctnNumber == this.rowData[j].ctnNumber){
                    this.rowData[j].selected = true;
                  }
              }
            }
          }
          if(backurl === '/manageInventory/deviceInventory'){
            this.selectedRowData = [];
          }
          this.customGridOptions.gridData = this.rowData;
          this.getFanStatusAndGroupsData();
          this.initGrid();
          this.pageloaderService.setPageLoaderStatus(true);
        },(error) => {
          this.handleError(error);
        })
    
    // this.pageloaderService.setPageLoaderStatus(true);
    // this.getData();
  }

  getData(){
    // this.dbService.connectToDb();
    this.dbService.getDb().then(db => {
      // Use the database
    
    this.dbService.getAllData('devices').then(data => {
      
    });
  });
  }

  getGroupingDevicesData() {
    var sessionId  = sessionStorage.getItem("sessionId");
    this.groupingDevicesService.getGroupDevicesData(this.selectedFan, sessionId)
      .subscribe(resposneObject => {
        console.log("resposneObject >>>>>> "+ JSON.stringify(resposneObject));
        var response = JSON.parse(JSON.stringify(resposneObject));
        localStorage.setItem('groupDeviceTableData', JSON.stringify(response));
      }, error => {
        this.handleError(error);
      });

      this.pageloaderService.setPageLoaderStatus(true);


  }

  getFanStatusAndGroupsData(){
    let groupSet = new Set();
    let statusSet = new Set();
    for(let i = 0 ; i < this.totalNumberOfRecords ; i++) {
     groupSet.add(this.rowData[i].group);
     //statusSet.add(this.rowData[i].status);
    }
    for (const x of groupSet.values()) {
      this.groupsOptions.push({name: x, value: x});
    }
    // for (const x of statusSet.values()) {
    //   this.statusOptions.push({name: x, value: x});
    // }
    sessionStorage.setItem('fanGroups', JSON.stringify(this.groupsOptions));
  }

  initGrid() {

    this.gridOptions = this.customGridOptions;
    this.customGridOptions.enableFiltering = false;
    this.customGridOptions.enableSorting = true;

    const pagination = {
      recordsPerPage: 15,
      currentPage: 1,
      isServerSide: false,
      totalRecords: this.totalNumberOfRecords,
      hideGoToPage: true
    };

    this.customGridOptions.enableBackLink = true;
    this.customGridOptions.backLinkText = "Back";
    this.customGridOptions.emptyMessage = "We didn't find any devices that match your search criteria.";
    this.customGridOptions.searchPlaceHolder = "";
    this.customGridOptions.ariaLabel = "";
    this.customGridOptions.callbacks = {
      callBackAppNameCellTemplate: this.callBackAppNameCellTemplate,
      callBackProfileStatus: this.callBackProfileStatus,
      callBackImei: this.callBackImei
    }
    this.customGridOptions.Paginations = pagination;
    //this.customGridOptions.gridData = this.groupingDevicesDetails.list;
    this.customGridOptions.columnDefinitions = this.selectDevicesCol.columnDefinitions;
    this.customGridOptions.multiSelect = true;
    this.customGridOptions.searchDescriptions = '';
    this.customGridOptions.ctnMask = false;
    this.customGridOptions.imeiMask = false;
    this.customGridOptions.maxLength = 15;
    this.customGridOptions.disableGrid = false;
    this.customGridOptions.disableRow = false;
    this.customGridOptions.disableRowCondition = { field: '', value: '' };

    // refine grid data for "Claimed_Android"
    this.customGridOptions.gridData.map(function (x) {
      if (x.status == "Claimed_Android") {
        x.status = "Claimed_Android™"
      }
    })
    this.gridOptions = this.customGridOptions;
    this.pageloaderService.setPageLoaderStatus(true);
    return this.gridOptions;

  }

  onRowClick(action) {
    var selectedDevicesForGrouping = this.rowData.filter(item => item.selected === true);
    this.numberOfRowsSelected = selectedDevicesForGrouping.length;
    if(this.numberOfRowsSelected>0){
      this.showNumberOfRowsSelected = true;
    }else{
      this.showNumberOfRowsSelected = false;
    }
    sessionStorage.setItem('selectedDevicesForGrouping', JSON.stringify(selectedDevicesForGrouping));
    console.log(selectedDevicesForGrouping);
    this.selectedRowData = selectedDevicesForGrouping;
  }

  cancel() {
    this.router.navigate(['/manageInventory/deviceInventory']);
  }

  continue() {
    this.stepIndicatorService.setCurrentStep("selectGroup");
    this.stepIndicatorService.setVisibility(true);
    this.router.navigate(['/groupingDevices/selectGroup']);
  }

  clearAll() {
    document.getElementById('ctnNumber')['value'] = '';
    document.getElementById('imei')['value'] = '';
    document.getElementById('deviceModel')['value'] = '';
    this.isctnNumberInvalid = false;
    this.isimeiNumberInvalid = false;
    this.isModelInvalid = false;

    this.showNumberOfRowsSelected = false;
    
    for(let i=0; i<this.selectedRowData.length; i++){
      for(let j=0; j<this.rowData.length; j++){
          if(this.selectedRowData[i].ctnNumber == this.rowData[j].ctnNumber){
            this.rowData[j].selected = false;
          }
      }
    }

    this.initGrid();


    sessionStorage.setItem('selectedDevicesForGrouping', null);


    this.defaultGroup = { name: "Select", value: "" }
    this.defaultStatus = { name: "Select", value: "" }

    this.selectStatusOption({ name: "Select", value: "" })
    this.selectGroupOption({ name: "Select", value: "" })
    this.searchDevices(0);
  }

  

  handleError(error) {
    this.pageloaderService.setPageLoaderStatus(true);
    //this.showError = true;
  }

  selectStatusOption(option) {
    this.status = option.value;
    console.log("search data group:::::::::::::::::::::::: " + this.status);
  }

  selectGroupOption(option) {
    this.group = option.value;
    console.log("search data group:::::::::::::::::::::::: " + this.group);
  }

  searchDevices(data) {
    this.pageloaderService.setPageLoaderStatus(false);
    this.filterRowData = this.rowData;
    for(let i=0; i<this.selectedRowData.length; i++){
      for(let j=0; j<this.rowData.length; j++){
          if(this.selectedRowData[i].ctnNumber == this.rowData[j].ctnNumber){
            this.rowData[j].selected = false;
          }
      }
    }
    this.showNumberOfRowsSelected = false;

    console.log("Before search filterRowData:::::::::::::::::::::::: " + this.filterRowData);

    this.ctn = document.getElementById('ctnNumber')['value'];
    this.imei = document.getElementById('imei')['value'];
    this.deviceModel = document.getElementById('deviceModel')['value'];

    if (data) {
      if (this.ctn) {
        this.filterRowData = this.filterRowData.filter(item => item.ctnNumber.includes(this.ctn));
      }
      if (this.imei) {
        this.filterRowData = this.filterRowData.filter(item => item.imei.includes(this.imei));
      }
      if (this.deviceModel) {
        this.filterRowData = this.filterRowData.filter(item => item.model.toUpperCase().includes(this.deviceModel.toUpperCase()));
      }
      if (this.status) {
        if(this.status == "Claimed_Android™"){
          this.filterRowData = this.filterRowData.filter(item => item.status == "Claimed_Android" || item.status == "Claimed_Android™");
        }else if(this.status == "CLAIM_PENDING_Android™"){
          this.filterRowData = this.filterRowData.filter(item => item.status == "CLAIM_PENDING_Android" || item.status == "CLAIM_PENDING_Android™");
        }else if(this.status == "UNCLAIM_PENDING_Android™"){
          this.filterRowData = this.filterRowData.filter(item => item.status == "UNCLAIM_PENDING_Android" || item.status == "UNCLAIM_PENDING_Android™");
        }else{
          this.filterRowData = this.filterRowData.filter(item => item.status === this.status);
        }
        // this.filterRowData = this.filterRowData.filter(item => item.status === this.status);
      }
      if (this.group) {
        this.filterRowData = this.filterRowData.filter(item => item.group === this.group);
      }
    }
    if(this.filterRowData && this.filterRowData.length ===0){
      this.showNumberOfRowsSelected = false;
    }
    console.log("After search filterRowData:::::::::::::::::::::::: " + this.filterRowData);
    console.log("After search filterRowData size:::::::::::::::::::::::: " + this.filterRowData.length);

    this.totalNumberOfRecords = this.filterRowData.length
    this.gridOptions = new GridOptionsModel;
    this.customGridOptions.gridData = this.filterRowData;
    this.customGridOptions.Paginations.currentPage = 1;
    this.customGridOptions.Paginations.totalRecords = this.customGridOptions.gridData.length;
    if(this.customGridOptions.gridData.length == 0){
      this.customGridOptions.multiSelect = false;
      this.customGridOptions.isEmptyMessageInRow = false;
    }else{
      this.customGridOptions.multiSelect = true;
    }

    this.gridOptions = Object.assign({}, this.customGridOptions);
    setTimeout(() => {
      this.pageloaderService.setPageLoaderStatus(true);
    }, 2000);
    // this.pageloaderService.setPageLoaderStatus(true);
    //this.gridOptions = JSON.parse(JSON.stringify(this.customGridOptions));
  }

  checkPattern(event) {

    if (!this.numberPattern.test(document.getElementById('ctnNumber')['value'])) {
      this.isctnNumberInvalid = true;
    }
    else {
      this.isctnNumberInvalid = false;
    }

    if (!this.numberPattern.test(document.getElementById('imei')['value'])) {
      this.isimeiNumberInvalid = true;
    }
    else {
      this.isimeiNumberInvalid = false; 
    }

    if (!this.modelPattern.test(document.getElementById('deviceModel')['value'])) {
      this.isModelInvalid = true;
    }
    else {
      this.isModelInvalid = false;
    }

  }

  /*add two cell for status updated in grid column */
  callBackProfileStatus(element, row, field, currentElem) {
    const colorStatus = row.status.replace(/_/g, '-').toLowerCase();
    let status = row.status.replace(/_/g, ' ');
    if (status === 'ENROLLED ACTIVE') {
      status = 'Enrolled, active';
    }else if (status === 'OUT OF COMPLIANCE') {
      status = 'Not compliant';
    }else if (status === 'ENROLLED NOT ACTIVE') {
      status = 'Enrolled, not active';
    }else if (status === 'NOT ENROLLED') {
      status = 'Not enrolled';
    }else if (status === 'Claimed Android™') {
      status = 'claimed (Android™)';
    }else if (status === 'Claimed Android') {
      status = 'claimed (Android™)';
    }else if (status === 'Claimed Samsung') {
      status = 'claimed (Samsung)';
    }else if (status === 'Claimed Apple') {
      status = 'claimed (Apple)';
    }else if (status === 'UNCLAIM PENDING Android™') {
      status = 'unclaim pending (Android™)';
    }else if (status === 'UNCLAIM PENDING Android') {
      status = 'unclaim pending (Android™)';
    }else if (status === 'UNCLAIM PENDING Samsung') {
      status = 'unclaim pending (Samsung)';
    }else if (status === 'UNCLAIM PENDING Apple') {
      status = 'unclaim pending (Apple)';
    }else if (status === 'CLAIM PENDING Android™') {
      status = 'claim pending (Android™)';
    }else if (status === 'CLAIM PENDING Android') {
      status = 'claim pending (Android™)';
    }else if (status === 'CLAIM PENDING Samsung') {
      status = 'claim pending (Samsung)';
    }else if (status === 'CLAIM PENDING Apple') {
      status = 'claim pending (Apple)';
    }else if (status === 'Not Claimed') {
      status = 'not claimed';
    }else if (status === 'UNCLAIM PENDING') {
      status = 'unclaim pending';
    }else if (status === 'CLAIM PENDING') {
      status = 'claim pending';
    }
    // return `<span class='${colorStatus} color-square custumgrid-field'></span><span class="custumgrid-field-status">${status}</span>`;
    return `<div class="gridText" > <span class='${colorStatus} color-square custumgrid-field'></span><span class="custumgrid-field-status">${status}</span> </div>`;

  }

  callBackImei(element, row, field, currentElem, type, col) {
    let imei = row.imei;
    let imei2 = row.complianceStatus
    if(imei2 == "Unknown" || imei2 === undefined || imei2 === "" || imei2 === null) {
      return `<span class="imei1">${imei}</span>`;
    }else{
      return `<span class="imei1">${imei}</span><p class="imei2">${imei2}</p>`;
    }
  }

  /*add two cell for link of CTN and username */
  callBackAppNameCellTemplate(element, row, field, currentElem, type, col) {
    if (type === 'template') { 
      if(row.ctnNumber == null || row.ctnNumber == "" || row.ctnNumber == "Unknown") {
        const formatctnNumber = "Unknown";
        return ` <span class='ctn-number'>${formatctnNumber}</span>`;
      } else {
        const formatctnNumber = row.ctnNumber.replace(/^(\d{0,3})(\d{0,3})(.*)/, '$1.$2.$3');
        return ` <span class='ctn-number'>${formatctnNumber}</span>`;
      }
    } else if (type.target.classList.contains('ctn-number')) {
      currentElem.onDataChange.emit({ data: row, type: 'ctnInfo' });
    }
  }


}
